import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  EntidadesProductiva
} from './entity-entidades-productiva.model';

@Injectable({
  providedIn: 'root'
})
export class EntidadesProductivaService {
  url: string;
  token: string;
  endpoint = 'entidadesProductiva';

  constructor(private http: HttpClient) { }

  getEntidadesProductiva(): Observable<EntidadesProductiva[]> {
    return this.http.get<EntidadesProductiva[]>(
      `${this.url}/${this.endpoint}/`,
      {
        params: { token: this.token }
      }
    );
  }

  addEntidadProductiva(
    entidadesProductiva: EntidadesProductiva
  ): Observable<EntidadesProductiva> {
    return this.http.post<EntidadesProductiva>(
      `${this.url}/${this.endpoint}/`,
      {
        ...entidadesProductiva
      }
    );
  }

  changeEntidadProductiva(
    p: EntidadesProductiva
  ): Observable<EntidadesProductiva> {
    return this.http.patch<EntidadesProductiva>(
      `${this.url}/${this.endpoint}/${p.id}/`,
      {
        ...p,
      }
    );
  }

  deleteEntidadProductiva(
    p: EntidadesProductiva
  ): Observable<EntidadesProductiva> {
    return this.http.delete<EntidadesProductiva>(
      `${this.url}/${this.endpoint}/${p.id}`,
      {
        params: { token: this.token }
      }
    );
  }
}
